export const servicesMenu = [
    { name: 'Contenuti', slug: '/contents', active: true },
    { name: 'Feeds', slug: '/externalFeeds', active: true },
    { name: 'WebinAR', slug: '/webinars', active: true }
]
